<mat-card *ngIf="!updateMode">{{'addCategory' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'updateCategory' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
  <!-- <span class="spacer"></span> -->

  <button mat-raised-button color="primary" (click)="submit()" [disabled]="arabName.invalid || engName.invalid">
    <mat-icon>done</mat-icon>
    {{'submit' | translate}}
  </button>
  &nbsp;
  <button mat-raised-button (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon>
    {{'back' | translate}}
  </button>
  &nbsp;
</div>


<mat-grid-list cols="5" rowHeight="100px">

  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'arabicName' | translate}}</mat-label>
      <input matInput [(ngModel)]="category.arabicName" required #arabName="ngModel">
      <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>

  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'englishName' | translate}}</mat-label>
      <input matInput [(ngModel)]="category.englishName" required #engName="ngModel">
      <mat-error *ngIf="engName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'categoryType' | translate}}</mat-label>
      <mat-select [(value)]="selectedType">
        <mat-option *ngFor="let type of catgType" [value]="type.id">
          {{type.name | translate}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'directCharged' | translate}}</mat-label>
      <mat-select [(value)]="category.directCharge" [disabled]="category.pytic == 1">
        <mat-option [value]="true"> {{'yes' | translate}} </mat-option>
        <mat-option [value]="false"> {{'no' | translate}} </mat-option>
      </mat-select>
    </mat-form-field>


  </mat-grid-tile>

  <mat-grid-tile>
    <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="active">{{'active' | translate}}</mat-checkbox>
  </mat-grid-tile>


</mat-grid-list>


<mat-grid-list cols="3" rowHeight="200px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>

    <input type="file" class="dropify" (change)="onSelectImage($event)" />
  </mat-grid-tile>
</mat-grid-list>


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>